import {
  CarStatusDashboardAllotmentDetailsResponse,
  CarStatusDashboardIdleCarDetailsResponse,
  CarStatusDashboardResponse,
  ChargerStatusDashboardDetailsResponse,
  ChargerStatusDashboardResponse,
} from "@/central-atoms/everest-fleet-pwa/responses";
import { API_BASE_URL } from "@/constants";
import { apiClient } from "../apiClient";

class DashboardService {
  static async getCarStatusDashboardDetails(
    hub?: string,
    type?: string,
    idle_slot?: number
  ): Promise<
    | CarStatusDashboardAllotmentDetailsResponse
    | CarStatusDashboardIdleCarDetailsResponse
  > {
    const response = await apiClient.get(
      `${API_BASE_URL}/supervisor/hub/car_status/dashboard/details`,
      {
        params: {
          hub,
          type,
          idle_slot,
        },
      }
    );
    return response.data;
  }

  static async getCarStatusDashboard(
    hub: string
  ): Promise<CarStatusDashboardResponse> {
    const response = await apiClient.get(
      `${API_BASE_URL}/supervisor/hub/car_status/dashboard`,
      {
        params: {
          hub,
        },
      }
    );
    return response.data;
  }

  static async getChargerStatusDashboard(
    hub: string
  ): Promise<ChargerStatusDashboardResponse> {
    const response = await apiClient.get(
      `${API_BASE_URL}/supervisor/hub/charger_status/dashboard`,
      {
        params: {
          hub,
        },
      }
    );
    return response.data;
  }

  static async getChargerStatusDashboardDetails(
    hub: string,
    type: string
  ): Promise<ChargerStatusDashboardDetailsResponse> {
    const response = await apiClient.get(
      `${API_BASE_URL}/supervisor/hub/charger_status/dashboard/details`,
      {
        params: {
          type,
          hub,
        },
      }
    );
    return response.data.data;
  }
}

export default DashboardService;
